import { IAuthUserChange, IAuthUserPasswordChange } from "@api/auth.int";
import { FormControl, FormLabel, Input, useBoolean, useToast } from "@chakra-ui/react";
import { useDeepAuth, useVVApi } from "components/api";
import { DeepErrorBox, DeepErrorContainer } from "components/misc";
import { useVVStore } from "components/store";
import { CardContentHead1, VizvButtonPrimary, VizvCard, VizvCardActionStrip, VizvCardContent, VizvCardHeader, VizvMainCol } from "components/vizvComponents";
import { useState } from "react";
import { useNavigate } from "react-router";



export function UserAccount() {

	const setMyProfile = useVVStore(state => state.setMyProfile);
	const auth = useDeepAuth();


	const [isLoading, setIsLoading] = useBoolean();
	const [error, setError] = useState('');

	const api = useVVApi();
	const toast = useToast();

	const onSubmitChangeUser = async (e: React.SyntheticEvent) => {
		e.preventDefault();
		const target = e.target as typeof e.target & {
			userName: { value: string };
			phoneNumber: { value: string };
		};
		const userName = target.userName.value;
		const phoneNumber = target.phoneNumber.value||'-';
		setIsLoading.on();
		setError('');
		try {
			const resp = await api.fetch<IAuthUserChange>({
				url: '/auth/user-change',
				method: 'POST',
				payload: {
					userName,
					phoneNumber,
				}
			});
			setMyProfile(resp.user);
			toast({ title: 'A változtatásokat lementettük', status: 'success' });
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}


	const onSubmitChangePass = async (e: React.SyntheticEvent) => {
		e.preventDefault();
		setIsLoading.on();
		setError('');

		const target = e.target as typeof e.target & {
			password: { value: string };
			passwordAgain: { value: string };
		};
		const password = target.password.value;
		const passwordAgain = target.passwordAgain.value;

		if (password != passwordAgain) {
			setError('Nem stimmel a két jelszó!');
			return;
		}

		try {
			const resp = await api.fetch<IAuthUserPasswordChange>({
				url: '/auth/password-change',
				method: 'POST',
				payload: {
					newPassword: password,
				}
			});
			target.password.value = '';
			target.passwordAgain.value = '';
			toast({ title: 'A jelszavad megváltozott!', status: 'success' });
		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading.off();
		}
	}


	return <VizvMainCol>
		<VizvCard isClosable>
			<DeepErrorContainer isLoading={isLoading} error={error} onErrorClose={() => setError('')} >
				<VizvCardHeader >Fiókom</VizvCardHeader>
				<form onSubmit={onSubmitChangeUser}>
					<fieldset disabled={isLoading}>
						<VizvCardContent>
							<CardContentHead1>Alapadatok</CardContentHead1>
							<FormControl>
								<FormLabel>Email cím</FormLabel>
								<Input isDisabled defaultValue={auth.userAny?.email} />
							</FormControl>
							<FormControl>
								<FormLabel>Felhasználói nevem</FormLabel>
								<Input type='text' autoComplete="off" name='userName' defaultValue={auth.userAny?.userName || ''} />
							</FormControl>
							<FormControl>
								<FormLabel>Telefonszámom</FormLabel>
								<Input type='tel' autoComplete="off" name='phoneNumber' defaultValue={auth.userAny?.phoneNumber || ''} />
							</FormControl>
						</VizvCardContent>
						<VizvCardActionStrip>
							<VizvButtonPrimary type='submit' isLoading={isLoading} ml='auto' >
								Változások mentése
							</VizvButtonPrimary>
						</VizvCardActionStrip>
					</fieldset>
				</form>


				<form onSubmit={onSubmitChangePass}>
					<fieldset disabled={isLoading}>
						<VizvCardContent>
							<CardContentHead1>Jelszó megváltoztatása</CardContentHead1>
							<Input type='text' autoComplete="username" name='username' defaultValue={auth.userAny?.email} display="none" />
							<FormControl>
								<FormLabel>Jelszó</FormLabel>
								<Input type='password' autoComplete="new-password" name='password' />
							</FormControl>
							<FormControl>
								<FormLabel>Jelszó még egyszer</FormLabel>
								<Input type='password' autoComplete="new-password" name='passwordAgain' />
							</FormControl>
						</VizvCardContent>
						<VizvCardActionStrip>
							<VizvButtonPrimary type='submit' isLoading={isLoading} ml='auto' >
								Jelszó megváltoztatása
							</VizvButtonPrimary>
						</VizvCardActionStrip>
					</fieldset>
				</form>
			</DeepErrorContainer>
		</VizvCard>
	</VizvMainCol>
}